import { render, staticRenderFns } from "./subscribe_init.vue?vue&type=template&id=247c39f7&lang=pug&"
import script from "./subscribe_init.vue?vue&type=script&lang=js&"
export * from "./subscribe_init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports